import React, { Component } from 'react'
import edit from "../../assets/images/edit.svg";
import delet from "../../assets/images/delet.svg";
import { Link, withRouter } from 'react-router-dom';
import Loader from '../../component/loader';
import service from '../../services';
import moment from 'moment-timezone'
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import ReactPaginate from 'react-paginate';
import ViewIcon from '../../icons/viewIcon';
import ShowPasswordIcon from '../../icons/ShowPassIcon';
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;
let sub;
class PartnerspatnersScreenings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imagePreloader: false,
            createOpen: false,
            offset: 0,
            perPage: 50,
            currentPage: 0,
            pageCount: 0,
            screenings: [],

            deleteId: '',
            deletepopup: false
        }
        this.apiserve = new service();
    }

    componentDidMount() {
        var data = {
            page: this.state.offset,
            limit: this.state.perPage
        }
        this.setState({loaderFlag:true})
        this.apiserve.sendevent("privateScreeningPartner|screen|getList", data);
        this.getData()
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    getData = () => {
        var self = this
        sub = this.apiserve.getevent().subscribe(response => {
            switch (response.event) {
                case "privateScreeningPartner|screen|getList":
                    if (!response.error) {
                        this.setState({
                            screenings: response.data.docs || [],
                            pageCount: Math.ceil(response.data.totalDocs / self.state.perPage),
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    this.setState({loaderFlag:false})
                    break;
                case "privateScreeningPartner|screen|remove":
                    if (!response.error) {
                        this.apiserve.success("Screening Deleted Sucessfully")
                        this.setState({
                            deleteId: '',
                            deletepopup: false,
                            screenings: [],
                            loaderFlag:true
                        })
                        var data = {
                            page: this.state.offset,
                            limit: this.state.perPage
                        }
                        this.apiserve.sendevent("privateScreeningPartner|screen|getList", data);
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break
                case "fpg|screenerCredential|addPassword":
                    if(!response.error){
                        this.setState({
                            screenmodal: false,
                            password:''
                        })
                    }else{
                        this.apiserve.error(response.data.error ? response.data.error : response.error )
                    }
                    break;
                default:
                    break;
            }
        });
    }

    CreatePartner = () => {
        this.props.history.push('/partner-add-screening');
    }
    editScreening = (id) => {
        localStorage.setItem('filmListlength', this.state.screenings.length)
        this.props.history.push('/partner-edit-screening/' + id)
    }
    deleteScreening = (id) => {
        this.setState({ deleteId: id, deletepopup: true })
    }

    deleteFilmPopupYes = () => {
        this.apiserve.sendevent("privateScreeningPartner|screen|remove", {
            screenId: this.state.deleteId
        });
    }
    closeAdminUser = () => {
        this.setState({
            deletepopup: false,
            deleteId: ''
        })
    }
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                var data = {
                    page: offset,
                    limit: this.state.perPage
                }
                this.apiserve.sendevent("privateScreeningPartner|screen|getList", data);
            }
        );
    };

    ScreenerPopup = (e,data) => {
        e.stopPropagation();
        this.setState({
            screenmodal:true,
            ScreenerPopupData:data,
        })
    }
    validate = () => {
        let passwordErr = '';
        if (!this.state.password) {
            passwordErr = 'Password can not be blank'
        }
        else {
            if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            }
        }

        this.setState({
            passwordErr
        })
        if (passwordErr) {
            return false
        }
        return true
    }

    scannerLogin = (e,date,item) => {
        e.stopPropagation();
        e.preventDefault();
        let data = {}
        data.film = date._id
        data.filmType = "PrivateScreeningPartnerScreen"
        let scannerLogin = this.apiserve.encrypt(data)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_CMS + 'ps-moderator/signin?data=' + scannerLogin);

        // this.props.history.push('/screening-signin')
    }
    scannerSave = (date,data) => {
        const isValid = this.validate()
        if (isValid && date) {
        var data = {
            "filmId": date._id,
            "filmType": "PrivateScreeningPartnerScreen",
            "password": this.state.password
        }
       this.apiserve.sendevent("fpg|screenerCredential|addPassword",data);
    }
    }

    Showpassword = () => {
        this.setState({
            showPass: !this.state.showPass
        })
    }

    render() {
        let profileName='';
        let data = JSON.parse(localStorage.getItem('persist:root'));
        if(data && data.profileName){
            profileName = JSON.parse(data.profileName);
        }
        const {ScreenerPopupData,ScreenerPopupFilmTitle,ScreenerPopupFilmData} = this.state
        return (
            <div className="right_side_wrapper">
                <div className="dashboard_header with_btn">
                    <div className="searchBlock">
                        <span className="d_flex d_flex_align_center"> {profileName && profileName.fname ? profileName.fname + ' ' + profileName.lname: ''}&nbsp;&nbsp;
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.75 1.75C2.75 1.94778 2.69135 2.14112 2.58147 2.30557C2.47159 2.47002 2.31541 2.59819 2.13268 2.67388C1.94996 2.74957 1.74889 2.76937 1.55491 2.73079C1.36093 2.6922 1.18275 2.59696 1.04289 2.45711C0.903041 2.31725 0.8078 2.13907 0.769215 1.94509C0.73063 1.75111 0.750433 1.55004 0.826121 1.36732C0.901809 1.18459 1.02998 1.02841 1.19443 0.918531C1.35888 0.80865 1.55222 0.750001 1.75 0.750001C2.01522 0.750001 2.26957 0.855357 2.45711 1.04289C2.64464 1.23043 2.75 1.48478 2.75 1.75ZM6 0.750001C5.80222 0.750001 5.60888 0.80865 5.44443 0.918531C5.27998 1.02841 5.15181 1.18459 5.07612 1.36732C5.00043 1.55004 4.98063 1.75111 5.01922 1.94509C5.0578 2.13907 5.15304 2.31725 5.29289 2.45711C5.43275 2.59696 5.61093 2.6922 5.80491 2.73079C5.99889 2.76937 6.19996 2.74957 6.38268 2.67388C6.56541 2.59819 6.72159 2.47002 6.83147 2.30557C6.94135 2.14112 7 1.94778 7 1.75C7 1.48478 6.89464 1.23043 6.70711 1.04289C6.51957 0.855357 6.26522 0.750001 6 0.750001ZM10.25 2.75C10.4478 2.75 10.6411 2.69135 10.8056 2.58147C10.97 2.47159 11.0982 2.31541 11.1739 2.13268C11.2496 1.94996 11.2694 1.74889 11.2308 1.55491C11.1922 1.36093 11.097 1.18275 10.9571 1.04289C10.8173 0.903041 10.6391 0.8078 10.4451 0.769215C10.2511 0.73063 10.05 0.750433 9.86732 0.826121C9.68459 0.901809 9.52841 1.02998 9.41853 1.19443C9.30865 1.35888 9.25 1.55222 9.25 1.75C9.25 2.01522 9.35536 2.26957 9.54289 2.45711C9.73043 2.64464 9.98478 2.75 10.25 2.75ZM1.75 5C1.55222 5 1.35888 5.05865 1.19443 5.16853C1.02998 5.27841 0.901809 5.43459 0.826121 5.61732C0.750433 5.80004 0.73063 6.00111 0.769215 6.19509C0.8078 6.38907 0.903041 6.56725 1.04289 6.70711C1.18275 6.84696 1.36093 6.9422 1.55491 6.98079C1.74889 7.01937 1.94996 6.99957 2.13268 6.92388C2.31541 6.84819 2.47159 6.72002 2.58147 6.55557C2.69135 6.39112 2.75 6.19778 2.75 6C2.75 5.73478 2.64464 5.48043 2.45711 5.29289C2.26957 5.10536 2.01522 5 1.75 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01922 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM10.25 5C10.0522 5 9.85888 5.05865 9.69443 5.16853C9.52998 5.27841 9.40181 5.43459 9.32612 5.61732C9.25043 5.80004 9.23063 6.00111 9.26922 6.19509C9.3078 6.38907 9.40304 6.56725 9.54289 6.70711C9.68275 6.84696 9.86093 6.9422 10.0549 6.98079C10.2489 7.01937 10.45 6.99957 10.6327 6.92388C10.8154 6.84819 10.9716 6.72002 11.0815 6.55557C11.1914 6.39112 11.25 6.19778 11.25 6C11.25 5.73478 11.1446 5.48043 10.9571 5.29289C10.7696 5.10536 10.5152 5 10.25 5ZM1.75 9.25C1.55222 9.25 1.35888 9.30865 1.19443 9.41853C1.02998 9.52841 0.901809 9.68459 0.826121 9.86732C0.750433 10.05 0.73063 10.2511 0.769215 10.4451C0.8078 10.6391 0.903041 10.8173 1.04289 10.9571C1.18275 11.097 1.36093 11.1922 1.55491 11.2308C1.74889 11.2694 1.94996 11.2496 2.13268 11.1739C2.31541 11.0982 2.47159 10.97 2.58147 10.8056C2.69135 10.6411 2.75 10.4478 2.75 10.25C2.75 9.98478 2.64464 9.73043 2.45711 9.54289C2.26957 9.35536 2.01522 9.25 1.75 9.25ZM6 9.25C5.80222 9.25 5.60888 9.30865 5.44443 9.41853C5.27998 9.52841 5.15181 9.68459 5.07612 9.86732C5.00043 10.05 4.98063 10.2511 5.01922 10.4451C5.0578 10.6391 5.15304 10.8173 5.29289 10.9571C5.43275 11.097 5.61093 11.1922 5.80491 11.2308C5.99889 11.2694 6.19996 11.2496 6.38268 11.1739C6.56541 11.0982 6.72159 10.97 6.83147 10.8056C6.94135 10.6411 7 10.4478 7 10.25C7 9.98478 6.89464 9.73043 6.70711 9.54289C6.51957 9.35536 6.26522 9.25 6 9.25ZM10.25 9.25C10.0522 9.25 9.85888 9.30865 9.69443 9.41853C9.52998 9.52841 9.40181 9.68459 9.32612 9.86732C9.25043 10.05 9.23063 10.2511 9.26922 10.4451C9.3078 10.6391 9.40304 10.8173 9.54289 10.9571C9.68275 11.097 9.86093 11.1922 10.0549 11.2308C10.2489 11.2694 10.45 11.2496 10.6327 11.1739C10.8154 11.0982 10.9716 10.97 11.0815 10.8056C11.1914 10.6411 11.25 10.4478 11.25 10.25C11.25 9.98478 11.1446 9.73043 10.9571 9.54289C10.7696 9.35536 10.5152 9.25 10.25 9.25Z" fill="white" />
                            </svg> &nbsp;&nbsp;
                            Screenings ({this.state.screenings && this.state.screenings.length})
                        </span>
                    </div>
                    <div className="button_block admin_user_twoBtn">
                        <Link className="head_btn pointer" onClick={this.CreatePartner}> Add Screening + </Link>
                    </div>
                </div>
                <div className="film_list_table striped_table">
                    <table className="fix_table_layout">
                        <thead>
                            <tr>
                                <th style={{ width: "325px" }}></th>
                                <th style={{ width: "220px" }}>Screening Date-Time (MT)</th>
                                <th style={{ width: "220px" }}>Invited/Subscribed</th>
                                {/* <th style={{ width: "150px" }}>Screening Limit</th> */}
                                <th style={{ width: "127px" }}></th>
                                <th style={{ width: "127px" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.screenings && this.state.screenings.map(item => {
                                    return (
                                        <tr className={`pointer`} onClick={() => this.editScreening(item._id)}>
                                            <td style={{ width: "325px" }}>
                                                <div className="disp_flex">
                                                    <div className="film_banner">
                                                        
                                                        <img src={
                                                            item.filmId && item.filmId.images && item.filmId.images[0].inSite && !EXT_VIDEO.test(item.filmId.images[0].inSite) ? this.apiserve.imageUrl + item.filmId.images[0].inSite :
                                                            item.filmId && item.filmId.images[0] && item.filmId.images[0].link && !EXT_VIDEO.test(item.filmId.images[0].link) ? item.filmId.images[0].link :
                                                                '/images/image-placeholder.png'}
                                                         />
                                                    </div>
                                                    <div className="film_desc">
                                                        <h3>{item.filmId && item.filmId.title}</h3>
                                                        <div className="disp_flex d_flex_align_center">
                                                            <span>{item.filmId && item.filmId.runTime} min</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: "220px" }}>
                                                <div>
                                                    <p>{item.screeningDate ? moment(item.screeningDate).tz('US/Mountain').format('MMM DD, YYYY - hh:mm A') : ''}</p>
                                                </div>
                                            </td>
                                            <td style={{ width: "220px" }}>
                                                <div> <p className="color_blue font_600"> {item.invited_subscribe}</p> </div>
                                            </td>
                                            {/* <td style={{ width: "150px" }}>
                                                <div> <p> {item.screeningLimit} </p> </div>
                                            </td> */}
                                            <td style={{ width: "127px" }} onClick={(e)=>e.stopPropagation(e)}>
                                                <div className="d_flex ">
                                                    <span className="mr_10 pointer" onClick={(e) => this.ScreenerPopup(e, item)}>
                                                        <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.33333 5.33333H3.33333V3.33333C3.33333 2.23067 4.23067 1.33333 5.33333 1.33333C6.436 1.33333 7.33333 2.23067 7.33333 3.33333H8.66667C8.66667 1.49533 7.17133 0 5.33333 0C3.49533 0 2 1.49533 2 3.33333V5.33333H1.33333C0.979711 5.33333 0.640573 5.47381 0.390524 5.72386C0.140476 5.97391 0 6.31305 0 6.66667V12C0 12.3536 0.140476 12.6928 0.390524 12.9428C0.640573 13.1929 0.979711 13.3333 1.33333 13.3333H9.33333C9.68695 13.3333 10.0261 13.1929 10.2761 12.9428C10.5262 12.6928 10.6667 12.3536 10.6667 12V6.66667C10.6667 6.31305 10.5262 5.97391 10.2761 5.72386C10.0261 5.47381 9.68695 5.33333 9.33333 5.33333ZM4.04067 8.99933C4.12261 8.68562 4.31596 8.41247 4.58459 8.23089C4.85321 8.04932 5.17876 7.97174 5.5004 8.01265C5.82205 8.05356 6.11781 8.21016 6.33243 8.4532C6.54705 8.69624 6.66586 9.0091 6.66667 9.33333C6.66628 9.56649 6.60446 9.79544 6.48742 9.9971C6.37038 10.1988 6.20226 10.366 6 10.482V12H4.66667V10.482C4.41441 10.3375 4.21656 10.1141 4.10348 9.8463C3.9904 9.57846 3.96833 9.28092 4.04067 8.99933Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                    <span className="mr_10 pointer" onClick={(e) => this.scannerLogin(e, item)}>
                                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.19997 0.133303C0.91707 0.133303 0.645759 0.245683 0.44572 0.445722C0.245681 0.645761 0.133301 0.917072 0.133301 1.19997V10.8C0.133301 11.0829 0.245681 11.3542 0.44572 11.5542C0.645759 11.7543 0.91707 11.8666 1.19997 11.8666H10.8C11.0829 11.8666 11.3542 11.7543 11.5542 11.5542C11.7543 11.3542 11.8666 11.0829 11.8666 10.8V7.06664C11.8666 6.92519 11.8104 6.78953 11.7104 6.68951C11.6104 6.58949 11.4748 6.5333 11.3333 6.5333C11.1919 6.5333 11.0562 6.58949 10.9562 6.68951C10.8562 6.78953 10.8 6.92519 10.8 7.06664V10.8H1.19997V1.19997H4.9333C5.07475 1.19997 5.21041 1.14378 5.31042 1.04376C5.41044 0.94374 5.46663 0.808085 5.46663 0.666636C5.46663 0.525187 5.41044 0.389532 5.31042 0.289512C5.21041 0.189493 5.07475 0.133303 4.9333 0.133303H1.19997ZM11.7109 0.289036C11.8101 0.388464 11.866 0.523 11.8666 0.663436V3.86664C11.8666 4.00809 11.8104 4.14374 11.7104 4.24376C11.6104 4.34378 11.4748 4.39997 11.3333 4.39997C11.1919 4.39997 11.0562 4.34378 10.9562 4.24376C10.8562 4.14374 10.8 4.00809 10.8 3.86664V1.9541L5.3109 7.44424C5.26131 7.49382 5.20245 7.53316 5.13766 7.55999C5.07287 7.58683 5.00343 7.60064 4.9333 7.60064C4.86317 7.60064 4.79373 7.58683 4.72895 7.55999C4.66416 7.53316 4.60529 7.49382 4.5557 7.44424C4.50611 7.39465 4.46678 7.33578 4.43994 7.27099C4.41311 7.2062 4.39929 7.13676 4.39929 7.06664C4.39929 6.99651 4.41311 6.92707 4.43994 6.86228C4.46678 6.79749 4.50611 6.73862 4.5557 6.68904L10.0458 1.19997H8.1333C7.99185 1.19997 7.8562 1.14378 7.75618 1.04376C7.65616 0.94374 7.59997 0.808085 7.59997 0.666636C7.59997 0.525187 7.65616 0.389532 7.75618 0.289512C7.8562 0.189493 7.99185 0.133303 8.1333 0.133303H11.3333C11.4034 0.133119 11.4728 0.146782 11.5376 0.173507C11.6024 0.200232 11.6613 0.239493 11.7109 0.289036Z" fill="black" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </td>
                                            <td style={{ width: "127px" }} onClick={(e)=>e.stopPropagation(e)}>
                                                <div className="d_flex d_flex_align_center">
                                                    <span className="mr_5 pointer"><img onClick={() => this.editScreening(item._id)} src={edit} /></span>
                                                    <span className="pointer"><img onClick={() => this.deleteScreening(item._id)} src={delet} /></span>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }


                        </tbody>
                    </table>
                    {this.state.screenings && this.state.pageCount > 0 ? (
                        <div className="custom-pagination">
                            <ReactPaginate
                                previousLabel={""}
                                nextLabel={""}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    ) : (
                            ""
                        )}
                    {/* Loader */}
                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                            ""
                        )}
                </div>
                {this.state.deletepopup ?
                    <PopUpCustomAll
                        HeaderName='Delete?'
                        insideDetails='You are about to delete an item and this action is permanent'
                        insideData='Do you want to proceed?'
                        popupState={this.closeAdminUser}
                        yesPopUp={() => this.deleteFilmPopupYes()}
                    />
                    : ''}

{   
                this.state.screenmodal ? 
                <div className="screener_popup">
                    <div className="screener_popup_innerpopup">
                        <div className="screener_popup_header text_center">
                            <h3 className="mb_10"> Screener Credentials</h3>
                            <p>{ScreenerPopupData.filmId && ScreenerPopupData.filmId.title} </p>
                            <p>{moment(ScreenerPopupData.screeningDate).tz("US/Mountain").format('MMM DD - h:mm A') + ' MT'} </p>
                        </div>
                        <div className="screener_popup_content">
                            <form>
                                <h3 className="mb_5">PIN</h3>
                                <h2 className="mb_15">{ScreenerPopupData.pin}</h2>
                                <div className="field_row">
                                    <div className="field_row_inner">
                                        <label>Password</label>
                                        <div className="field_input relative">
                                            <input
                                                type={this.state.showPass ? "text" : "password"}
                                                name="password"
                                                id="password"
                                                value={this.state.password}
                                                onChange={(e)=>this.setState({password: e.target.value})}
                                            />

                                            <span style={{ color: 'red' }} className='srv-validation-message'>{this.state.passwordErr}</span>

                                            <span className="eye_icon"  onClick={this.Showpassword}> { this.state.showPass ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="field_row pt_25">
                                    <button type='button' onClick={() => this.setState({screenmodal:false, ScreenerPopupData:{}})}>CANCEL</button>
                                    <button className="active" type='button' onClick={()=>this.scannerSave(ScreenerPopupData)}>SAVE</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                :
                ""       
            }
            </div>


        )
    }
}


export default withRouter(PartnerspatnersScreenings)
